import React from "react";
import { Check, ChevronRight } from "lucide-react";
import { WHY_CHOOSE } from "../mock";
import { useValuation } from "./ValuationDialog";

export default function WhyChoose() {
  const { openValuation } = useValuation();
  return (
    <section id="landlords" className="relative overflow-hidden py-20 lg:py-28">
      <img src={WHY_CHOOSE.bg} alt="" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-black/70" />
      <div className="relative z-10 mx-auto max-w-[1200px] px-5">
        <div className="grid gap-12 lg:grid-cols-2 lg:items-center">
          <div>
            <h2 className="font-display text-4xl font-700 uppercase tracking-wide text-white lg:text-6xl">
              {WHY_CHOOSE.title}
            </h2>
            <p className="mt-6 max-w-lg text-[15px] leading-relaxed text-white/85">
              {WHY_CHOOSE.intro}
            </p>
            <div className="mt-8">
              <button
                onClick={openValuation}
                className="group flex items-center justify-center gap-2 bg-[#ec008c] px-7 py-3 text-xs font-semibold uppercase tracking-[0.2em] text-white transition-colors hover:bg-[#c60074]"
              >
                Request a Valuation
                <ChevronRight size={16} className="transition-transform group-hover:translate-x-1" />
              </button>
            </div>
          </div>
          <ul className="space-y-4">
            {WHY_CHOOSE.points.map((p) => (
              <li
                key={p}
                className="flex items-center gap-4 border-b border-white/15 pb-4 text-white"
              >
                <span className="grid h-8 w-8 shrink-0 place-items-center border-2 border-[#ec008c] text-[#ec008c]">
                  <Check size={18} strokeWidth={3} />
                </span>
                <span className="text-[15px] font-medium">{p}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
